export default __webpack_public_path__ + "static/media/sports.5b143450.jpg";